import pushRBox from './pushRBox';

const pushRBoxMode = (mode, container, placement, target_type = 'mix') => {
    pushRBox({ mode, container, placement, target_type });
};

export default pushRBoxMode;
